module.exports = __webpack_public_path__ + "img/Location.fbd7c83e.svg";